var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i51633551-df2a-43b4-b4ac-800241263abd-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.089 0c.503 0 .911.436.911.972v10.055c0 .536-.408.973-.911.973H6.912C6.409 12 6 11.563 6 11.027V.972C6 .436 6.409 0 6.912 0Zm-6 0C3.592 0 4 .436 4 .972v10.055c0 .536-.408.973-.911.973H.912C.409 12 0 11.563 0 11.027V.972C0 .436.409 0 .912 0ZM8.8 1.2H7.2v9.6h1.6V1.2Zm-6 0H1.2v9.6h1.6V1.2Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i51633551-df2a-43b4-b4ac-800241263abd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0v16H0V0h16Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i51633551-df2a-43b4-b4ac-800241263abd-0)",
    transform: "translate(3 2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h10v12H0V0z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i51633551-df2a-43b4-b4ac-800241263abd)",
    transform: "translate(-3 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3 2h10v12H3V2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.699c6f603d8835718b3395bf4f74abb2.svg";
export { ForwardRef as ReactComponent };